import { render } from "./UploadAreaMappingList.vue?vue&type=template&id=7d0cb1e2&scoped=true"
import script from "./UploadAreaMappingList.vue?vue&type=script&lang=js"
export * from "./UploadAreaMappingList.vue?vue&type=script&lang=js"

import "./UploadAreaMappingList.vue?vue&type=style&index=0&id=7d0cb1e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d0cb1e2"

export default script